import MainRoute from './main.route';
angular.module('BTMS')
.config(MainRoute);

require('./home');
require('./choose-seat');
require('./buy-ticket');
require('./payment-ready');
require('./about-us');
require('./contacts');
require('./offices');
require('./how-to');
require('./rent');
require('./recomendations');
require('./terms-and-conditions');
require('./terms');
require('./privacy');
require('./cookie-policy');




/** WEBPACK FOOTER **
 ** ./client/public/main/index.js
 **/